module.exports = __webpack_public_path__ + "img/logo-powerline-icon.137ef2ca.png";